var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotfoundBoitier(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 470.08 247.54",
    style: {
      enableBackground: "new 0 0 470.08 247.54"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#D0DAD6;}\n\t.st1{fill:#80999B;}\n\t.st2{fill:#EFF2F1;}\n\t.st3{fill:#FFFFFF;}\n\t.st4{fill:#D1D8D8;}\n\t.st5{fill:#8597A0;}\n\t.st6{opacity:0.1;}\n\t.st7{fill:#C8D1C9;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "389.74,81.47 66.01,81.47 63.58,86.36 392.04,86.36  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M382.85,66.77c-0.57-1.22-1.3-2.34-2.14-3.35H75.43c-0.78,0.92-1.45,1.94-2,3.05l-0.84,1.69h310.9 L382.85,66.77z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "392.59,87.54 63,87.54 60.58,92.43 394.88,92.43  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "395.43,93.61 60,93.61 57.57,98.5 397.72,98.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "386.9,75.41 69.01,75.41 66.59,80.3 389.19,80.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "50.73,112.32 404.2,112.32 401.12,105.74 53.99,105.74  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M369.04,57.99H87.1c-4.01,0-7.77,1.57-10.57,4.26h303.07C376.82,59.56,373.05,57.99,369.04,57.99z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "398.27,99.68 56.99,99.68 54.57,104.57 400.57,104.57  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "384.06,69.34 72.02,69.34 69.59,74.23 386.35,74.23  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M75.43,63.42c0.35-0.41,0.71-0.81,1.1-1.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M379.61,62.24c0.39,0.37,0.75,0.76,1.1,1.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M379.61,62.24H76.53c-0.39,0.37-0.75,0.76-1.1,1.18h305.28C380.36,63.01,379.99,62.62,379.61,62.24z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 72.02,
    y1: 69.34,
    x2: 72.6,
    y2: 68.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 383.5,
    y1: 68.16,
    x2: 384.06,
    y2: 69.34
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "383.5,68.16 72.6,68.16 72.02,69.34 384.06,69.34  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 386.35,
    y1: 74.23,
    x2: 386.9,
    y2: 75.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 69.01,
    y1: 75.41,
    x2: 69.59,
    y2: 74.23
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "386.35,74.23 69.59,74.23 69.01,75.41 386.9,75.41  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 389.19,
    y1: 80.3,
    x2: 389.74,
    y2: 81.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 66.01,
    y1: 81.47,
    x2: 66.59,
    y2: 80.3
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "389.19,80.3 66.59,80.3 66.01,81.47 389.74,81.47  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 63,
    y1: 87.54,
    x2: 63.58,
    y2: 86.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 392.04,
    y1: 86.36,
    x2: 392.59,
    y2: 87.54
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "392.04,86.36 63.58,86.36 63,87.54 392.59,87.54  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 394.88,
    y1: 92.43,
    x2: 395.43,
    y2: 93.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 60,
    y1: 93.61,
    x2: 60.58,
    y2: 92.43
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "394.88,92.43 60.58,92.43 60,93.61 395.43,93.61  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 56.99,
    y1: 99.68,
    x2: 57.57,
    y2: 98.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 397.72,
    y1: 98.5,
    x2: 398.27,
    y2: 99.68
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "397.72,98.5 57.57,98.5 56.99,99.68 398.27,99.68  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 53.99,
    y1: 105.74,
    x2: 54.57,
    y2: 104.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 400.57,
    y1: 104.57,
    x2: 401.12,
    y2: 105.74
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "54.57,104.57 53.99,105.74 401.12,105.74 400.57,104.57  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 441.72,
    y: 193.99,
    transform: "matrix(0.7602 -0.6497 0.6497 0.7602 -36.3715 342.7515)",
    className: "st1",
    width: 8.83,
    height: 53.32
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M440.62,203.9l27.87,32.71c2.38,2.78,2.05,6.96-0.73,9.34c-1.25,1.07-2.78,1.59-4.3,1.59 c-1.87,0-3.73-0.79-5.04-2.32l-27.87-32.71L440.62,203.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M410.15,144.01v33.78c0,5.62-4.56,10.18-10.18,10.18H377.6c0,0-1.81-16.91,5.02-27.42 C389.45,150.04,397.45,146.89,410.15,144.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M375.83,184.33H56.83c-5.16,0-9.34-4.18-9.34-9.34v-55.6c0-5.16,4.18-9.34,9.34-9.34H398.1 c5.16,0,9.34,4.18,9.34,9.34v23.15c0,0-21.38,2.55-27.23,15.1C374.36,170.19,375.83,184.33,375.83,184.33z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 66.28,
    cy: 162.51,
    r: 8.42
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 89.83,
    cy: 162.51,
    r: 8.42
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 337.68,
    cy: 162.51,
    r: 8.42
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 392.85,
    cy: 164.18,
    r: 9.18
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 371.79,
    cy: 152.83,
    r: 8.42
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 349.2,
    cy: 148.55,
    r: 3.27
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 372.63,
    cy: 155.08,
    r: 6.11
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "195.61,132.63 190.92,127.95 185.22,133.66 179.51,127.95 174.82,132.63 180.53,138.34 174.82,144.05  179.51,148.74 185.22,143.03 190.92,148.74 195.61,144.05 189.9,138.34  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "280.02,132.63 275.33,127.95 269.62,133.66 263.91,127.95 259.23,132.63 264.94,138.34 259.23,144.05  263.91,148.74 269.62,143.03 275.33,148.74 280.02,144.05 274.31,138.34  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M236.14,167.84c-0.55,0-1.08-0.31-1.33-0.85c-1.33-2.84-4.2-4.67-7.33-4.67c-3.13,0-6.01,1.83-7.33,4.67 c-0.34,0.74-1.22,1.05-1.96,0.71c-0.74-0.34-1.05-1.22-0.71-1.96c1.81-3.87,5.73-6.37,10-6.37c4.27,0,8.19,2.5,10,6.37 c0.34,0.74,0.03,1.61-0.71,1.96C236.56,167.8,236.35,167.84,236.14,167.84z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 408.64,
    cy: 175.18,
    r: 29.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "411.25,210.24 399.31,206.91 433.96,155.2 441.47,165.13  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 380.13,
    y: 176.2,
    transform: "matrix(0.5566 -0.8308 0.8308 0.5566 34.741 420.4386)",
    className: "st3",
    width: 62.24,
    height: 2.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M408.24,212.36c-9.66,0-18.75-3.76-25.58-10.6s-10.6-15.92-10.6-25.58c0-9.66,3.76-18.75,10.6-25.58 s15.92-10.6,25.58-10.6c9.66,0,18.75,3.76,25.58,10.6c6.83,6.83,10.6,15.92,10.6,25.58c0,9.66-3.76,18.75-10.6,25.58 C426.99,208.59,417.9,212.36,408.24,212.36z M408.24,148.83c-15.08,0-27.35,12.27-27.35,27.35s12.27,27.35,27.35,27.35 c15.08,0,27.35-12.27,27.35-27.35S423.32,148.83,408.24,148.83z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M53.41,0.56c4.57,1.19,8.05,3.81,10.45,7.87c2.06,3.48,2.79,7.2,2.19,11.17c-0.55,3.91-2.15,7.12-4.81,9.64 l2.38,4.02c0.57,0.97,0.72,2.04,0.44,3.2c-0.29,1.15-0.95,2.02-1.95,2.62l-0.09,0.05c-1.01,0.6-2.09,0.75-3.23,0.45 c-1.16-0.31-2.04-0.98-2.63-1.99l-4.29-7.26c-0.6-1.01-0.75-2.09-0.45-3.23c0.27-1.13,0.91-2.01,1.91-2.63l0.15-0.09 c2.02-1.19,3.31-2.9,3.88-5.13c0.58-2.26,0.27-4.4-0.92-6.42c-1.19-2.02-2.92-3.32-5.18-3.9c-2.23-0.57-4.35-0.26-6.37,0.93 c-1.63,0.96-2.79,2.3-3.5,4.03c-0.7,1.69-0.84,3.43-0.42,5.21c0.24,0.92,0.17,1.81-0.21,2.67c-0.36,0.85-0.95,1.52-1.77,2.01 l-0.09,0.05c-1.24,0.73-2.52,0.82-3.84,0.27c-0.88-0.37-1.55-0.93-2-1.69c-0.22-0.37-0.38-0.79-0.49-1.25 c-0.88-3.6-0.6-7.12,0.83-10.58c1.46-3.5,3.82-6.22,7.1-8.16C44.52,0.03,48.84-0.59,53.41,0.56z M68.63,50.26 c-1.19,0.71-2.46,0.89-3.81,0.54c-1.34-0.34-2.37-1.11-3.08-2.31c-0.69-1.17-0.87-2.43-0.52-3.78c0.34-1.34,1.11-2.37,2.31-3.07 c1.17-0.69,2.43-0.87,3.78-0.52c1.35,0.31,2.38,1.07,3.09,2.26c0.72,1.22,0.89,2.49,0.51,3.83 C70.57,48.55,69.81,49.57,68.63,50.26z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M107.17,8.72c-2.23,0-4.04-1.81-4.04-4.04s1.81-4.04,4.04-4.04c2.23,0,4.04,1.81,4.04,4.04 S109.4,8.72,107.17,8.72z M107.17,2.11c-1.42,0-2.57,1.15-2.57,2.57s1.15,2.57,2.57,2.57s2.57-1.15,2.57-2.57 S108.59,2.11,107.17,2.11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M438.54,109.98c-2.98,0-5.41-2.43-5.41-5.41c0-2.98,2.43-5.41,5.41-5.41c2.99,0,5.41,2.43,5.41,5.41 C443.95,107.55,441.53,109.98,438.54,109.98z M438.54,100.62c-2.17,0-3.94,1.77-3.94,3.94c0,2.17,1.77,3.94,3.94,3.94 c2.17,0,3.94-1.77,3.94-3.94C442.48,102.39,440.71,100.62,438.54,100.62z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M5.41,171.41c-2.98,0-5.41-2.43-5.41-5.41c0-2.98,2.43-5.41,5.41-5.41s5.41,2.43,5.41,5.41 C10.83,168.98,8.4,171.41,5.41,171.41z M5.41,162.05c-2.17,0-3.94,1.77-3.94,3.94c0,2.17,1.77,3.94,3.94,3.94 c2.17,0,3.94-1.77,3.94-3.94C9.36,163.82,7.59,162.05,5.41,162.05z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M239.89,209.13c-2.23,0-4.04-1.81-4.04-4.04c0-2.23,1.81-4.04,4.04-4.04c2.23,0,4.04,1.81,4.04,4.04 C243.94,207.32,242.12,209.13,239.89,209.13z M239.89,202.51c-1.42,0-2.57,1.15-2.57,2.57c0,1.42,1.15,2.57,2.57,2.57 c1.42,0,2.57-1.15,2.57-2.57C242.47,203.67,241.31,202.51,239.89,202.51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M18.72,140.15c-0.41,0-0.74-0.33-0.74-0.74v-9.98c0-0.41,0.33-0.74,0.74-0.74s0.74,0.33,0.74,0.74v9.98 C19.46,139.82,19.13,140.15,18.72,140.15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M23.71,135.16h-9.98c-0.41,0-0.74-0.33-0.74-0.74s0.33-0.74,0.74-0.74h9.98c0.41,0,0.74,0.33,0.74,0.74 S24.12,135.16,23.71,135.16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M411.25,64.2c-0.41,0-0.74-0.33-0.74-0.74v-6.7c0-0.41,0.33-0.74,0.74-0.74s0.74,0.33,0.74,0.74v6.7 C411.99,63.87,411.66,64.2,411.25,64.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M414.6,60.85h-6.7c-0.41,0-0.74-0.33-0.74-0.74s0.33-0.74,0.74-0.74h6.7c0.41,0,0.74,0.33,0.74,0.74 S415.01,60.85,414.6,60.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M140.25,23.17c-0.19,0-0.38-0.07-0.52-0.22c-0.29-0.29-0.29-0.75,0-1.04l4.74-4.74c0.29-0.29,0.75-0.29,1.04,0 c0.29,0.29,0.29,0.75,0,1.04l-4.74,4.74C140.62,23.1,140.44,23.17,140.25,23.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M144.99,23.17c-0.19,0-0.38-0.07-0.52-0.22l-4.74-4.74c-0.29-0.29-0.29-0.75,0-1.04 c0.29-0.29,0.75-0.29,1.04,0l4.74,4.74c0.29,0.29,0.29,0.75,0,1.04C145.36,23.1,145.18,23.17,144.99,23.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M299.18,227.45c-0.19,0-0.38-0.07-0.52-0.22c-0.29-0.29-0.29-0.75,0-1.04l4.74-4.74 c0.29-0.29,0.75-0.29,1.04,0c0.29,0.29,0.29,0.75,0,1.04l-4.74,4.74C299.56,227.38,299.37,227.45,299.18,227.45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M303.92,227.45c-0.19,0-0.38-0.07-0.52-0.22l-4.74-4.74c-0.29-0.29-0.29-0.75,0-1.04 c0.29-0.29,0.75-0.29,1.04,0l4.74,4.74c0.29,0.29,0.29,0.75,0,1.04C304.3,227.38,304.11,227.45,303.92,227.45z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotfoundBoitier);
export default __webpack_public_path__ + "static/media/Notfound-boitier.459ed260e6e251676c1a03c10c762438.svg";
export { ForwardRef as ReactComponent };